import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// Defaults to the last 7 days server-side when either bound is missing, so the
// page can mount before the user has picked anything.
const qs = (range, filters, extra) => {
  const p = new URLSearchParams();
  if (range?.from) p.set('from', range.from);
  if (range?.to) p.set('to', range.to);
  for (const [k, v] of Object.entries(filters || {})) if (v) p.set(k, v);
  for (const [k, v] of Object.entries(extra || {})) if (v) p.set(k, v);
  const s = p.toString();
  return s ? `?${s}` : '';
};

// Filter options are scoped to the period, so a van or engineer with nothing
// in range never appears in the dropdowns.
export function useJobCardStockFilters(range) {
  return useQuery({
    queryKey: ['jobCardStock', 'filters', range?.from, range?.to],
    queryFn: async () => (await api.get(`/api/job-card-stock/filters${qs(range)}`)).data,
    staleTime: 60_000,
  });
}

// Totals per item. Honours the same filters as the list, so the numbers always
// describe the set of job cards on screen.
export function useJobCardStockSummary(range, filters) {
  return useQuery({
    queryKey: ['jobCardStock', 'summary', range, filters],
    queryFn: async () => (await api.get(`/api/job-card-stock/summary${qs(range, filters)}`)).data.items,
    staleTime: 30_000,
  });
}

// Paged server-side: at ~500 job cards a day the browser must never receive
// the whole period.
export function useJobCardStockJobs(range, filters, page, pageSize) {
  return useQuery({
    queryKey: ['jobCardStock', 'jobs', range, filters, page, pageSize],
    queryFn: async () =>
      (await api.get(`/api/job-card-stock/jobs${qs(range, filters, { page, pageSize })}`)).data,
    staleTime: 30_000,
    keepPreviousData: true,
  });
}

export function useJobCardStockFaulty(range) {
  return useQuery({
    queryKey: ['jobCardStock', 'faulty', range?.from, range?.to],
    queryFn: async () => (await api.get(`/api/job-card-stock/faulty${qs(range)}`)).data.faulty,
    staleTime: 30_000,
  });
}
